export class CatalogDependenciesObject {
    private _dependencies: any;
    private _length: number;

    constructor(dependencies: any, length: number) {
        this._dependencies = dependencies;
        this._length = length;
    }

    static create(): CatalogDependenciesObject {
        return new CatalogDependenciesObject('', 0);
    }

    public get dependencies(): any {
        return this._dependencies;
    }

    public get length(): number {
        return this._length;
    }

}
